/*
 * @Author: Json Chen
 * @Date: 2021-07-13 17:44:25
 * @LastEditTime: 2021-07-13 17:45:11
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/index.ts
 */

import { get } from 'src/tools/server';

export const getStoreCountries = (keyword) => {
  return get<any>(`/portal/setting/store/countries`, {});
};
